<style lang="scss">
.hooper {
  height: 100%;
}
</style>

<template>
  <app-layout>
    <hooper :settings="hooperSettings">
      <slide>
        <quotations />
      </slide>
      <slide>
        <valorization />
      </slide>
      <slide>
        <futures />
      </slide>
    </hooper>
  </app-layout>
</template>

<script>
import 'hooper/dist/hooper.css';
import { Hooper, Slide } from 'hooper';
import Futures from './Futures/Futures';
import Quotations from './Quotations/Quotations';
import Valorization from './Valorization/Valorization';

export default {
  name: 'Home',
  components: {
    Futures,
    Hooper,
    Quotations,
    Slide,
    Valorization,
  },
  data() {
    return {
      hooperSettings: {
        autoPlay: true,
        infiniteScroll: true,
        playSpeed: 10000,
        transition: 1000,
        hoverPause: false,
        vertical: true,
      },
    };
  },
  mounted() {
    this.planPageRefresh();
  },
  methods: {
    planPageRefresh() {
      // this.refreshOnSetTime();
      this.refreshOnInterval();
    },
    refreshOnInterval() {
      const now = new Date();
      const refreshTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), now.getHours() + 3);

      const millisecondsUntilRefresh = refreshTime - now;

      console.log(`App refresh planned at: ${new Date(now.getTime() + millisecondsUntilRefresh)}`);

      setTimeout(() => {
        window.location.reload();
      }, millisecondsUntilRefresh);
    },
    refreshOnSetTime() {
      const now = new Date();
      const refreshTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 3);

      let millisecondsUntilRefresh = refreshTime - now;
      if (millisecondsUntilRefresh < 0) {
        millisecondsUntilRefresh += 24 * 60 * 60 * 1000; // Add a whole day
      }

      console.log(`App refresh planned at: ${new Date(now.getTime() + millisecondsUntilRefresh)}`);

      setTimeout(() => {
        window.location.reload();
      }, millisecondsUntilRefresh);
    },
  },
};
</script>
